<template>
	<div :class="[loaction != '/home/visualization'?'home':'home visualization']">
		<el-container>
		  <el-header>
			<div class="homeUserNav">
				<headers :bg="bg.flag"></headers>
			</div>
		  </el-header>
		  <el-main class="commonSty">
			<div class="postr">
				<img src="../../assets/images/dark/404.png" alt="" style="width: 720px;height: 408px;">
				<div class="errorText">
					<div class="center">抱歉! 未找到该页面</div>
					<div class="errorBtn">
						<el-button type="primary" @click="backHome" round>返回首页</el-button>
					</div>
				</div>
			</div>
		  </el-main>
		</el-container>
	</div>
</template>

<script>
	import Headers from "@/components/Common/header"
	export default{
		name: 'error404',
		data() {
			return {
				userName: JSON.parse(localStorage.getItem('user')),
				userNameType: JSON.parse(JSON.parse(localStorage.getItem('user')).permissions)[0].KeyName,
				loaction: "",
			}
		},
		components: {
			Headers
		},
		watch: {
			$route(to, from) {
				this.loaction = to.path;
			}
		},
		computed: {
			...Vuex.mapState('breadcrumb', ['bg']),
		},
		methods:{
			backHome(){
				this.$router.push("/")
			}
		}
	}
</script>

<style>
</style>
